import React, { Fragment } from 'react';
import styles from './index.less';
import Link from '../../components/link';
import wrapStore from '../../utils/wrap-store';
import FooterStore from './store';
import useStore from '../../utils/hooks/use-store';
import cx from 'classnames';

import ToTopBtn from '@src/business-components/to-top-btn';
import classNames from 'classnames';
import $$tracker from '@src/tracker';
const Footer = () => {
  const store = useStore(() => new FooterStore());
  const { layerData, bottomLinkGroup } = store;

  return (
    // store.oversea &&
    <div className={classNames(styles.footer, styles.oversea)} data-flm-layer-name="footer">
      {layerData ? (
        <div className={styles.footer_container}>
          <div className={styles.footer_top}>
            <div className={styles.footer_information_container}>
              <ul className={styles.information_list}>
                <div className={styles.information_title}>{layerData.nav_bar[0]?.nav_title}</div>
                <li>
                  <Link href={layerData.nav_bar[0]?.link1_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[0]?.link1_txt)}>
                    <li>{layerData.nav_bar[0]?.link1_txt}</li>
                  </Link>
                </li>
                <li>
                  <Link href={layerData.nav_bar[0]?.link2_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[0]?.link2_txt)}>
                    <li>{layerData.nav_bar[0]?.link2_txt}</li>
                  </Link>
                </li>
                <li>
                  <Link href={layerData.nav_bar[0]?.link3_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[0]?.link3_txt)}>
                    <li>{layerData.nav_bar[0]?.link3_txt}</li>
                  </Link>
                </li>
              </ul>
              <ul className={styles.information_list}>
                <div className={styles.information_title}>{layerData.nav_bar[1]?.nav_title}</div>
                <li>
                  <Link href={layerData.nav_bar[1]?.link1_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[1]?.link1_txt)}>
                    {layerData.nav_bar[1]?.link1_txt}
                  </Link>
                </li>
                <li>
                  <Link href={layerData.nav_bar[1]?.link2_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[1]?.link2_txt)}>
                    {layerData.nav_bar[1]?.link2_txt}
                  </Link>
                </li>
                <li>
                  <Link href={layerData.nav_bar[1]?.link3_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[1]?.link3_txt)}>
                    {layerData.nav_bar[1]?.link3_txt}
                  </Link>
                </li>
                <li>
                  <Link href={layerData.nav_bar[1]?.link4_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[1]?.link4_txt)}>
                    {layerData.nav_bar[1]?.link4_txt}
                  </Link>
                </li>
              </ul>
              <ul className={styles.information_list}>
                <div className={styles.information_title}>{layerData.nav_bar[2]?.nav_title}</div>
                <li>
                  <Link href={layerData.nav_bar[2]?.link1_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[2]?.link1_txt)}>
                    {layerData.nav_bar[2]?.link1_txt}
                  </Link>
                </li>
                <li>
                  <Link href={layerData.nav_bar[2]?.link2_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[2]?.link2_txt)}>
                    {layerData.nav_bar[2]?.link2_txt}
                  </Link>
                </li>
              </ul>
              <ul className={styles.information_list}>
                <div className={styles.information_title}>{layerData.nav_bar[3]?.nav_title}</div>
                <li>
                  <Link href={layerData.nav_bar[3]?.link1_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[3]?.link1_txt)}>
                    {layerData.nav_bar[3]?.link1_txt}
                  </Link>
                </li>
                <li>
                  <Link href={layerData.nav_bar[3]?.link2_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[3]?.link2_txt)}>
                    {layerData.nav_bar[3]?.link2_txt}
                  </Link>
                </li>
                <li>
                  <Link href={layerData.nav_bar[3]?.link3_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[3]?.link3_txt)}>
                    {layerData.nav_bar[3]?.link3_txt}
                  </Link>
                </li>
              </ul>
              <ul className={styles.information_list}>
                <div className={styles.information_title}>{layerData.nav_bar[4]?.nav_title}</div>
                <li>
                  <Link href={layerData.nav_bar[4]?.link1_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[4]?.link1_txt)}>
                    {layerData.nav_bar[4]?.link1_txt}
                  </Link>
                </li>
                <li>
                  <Link
                    onMouseOver={store.onMouseoverState}
                    onMouseLeave={store.onMouseleaveState}
                    onClick={() => $$tracker.clickFooter(layerData.nav_bar[0]?.link1_txt)}
                  >
                    {layerData.nav_bar[4]?.qrcode_txt}
                  </Link>
                </li>
              </ul>
              <ul className={styles.information_list}>
                <div className={styles.information_title}>{layerData.nav_bar[6]?.nav_title}</div>
                <li>
                  <Link href={layerData.nav_bar[6]?.link1_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[6]?.link1_txt)}>
                    {layerData.nav_bar[6]?.link1_txt}
                  </Link>
                </li>
                <li>
                  <Link href={layerData.nav_bar[6]?.link2_url} target={'_blank'} onClick={() => $$tracker.clickFooter(layerData.nav_bar[6]?.link2_txt)}>
                    {layerData.nav_bar[6]?.link2_txt}
                  </Link>
                </li>
              </ul>
            </div>
            <div className={styles.r_top}>
              {/* <LanguageSelect buttonDisplay={'footer'} /> */}
              <div className={styles.topBtn}>
                <ToTopBtn />
              </div>
            </div>
          </div>
          <div className={styles.footer_bottom}>
            <div className={styles.l_bottom}>
              <p>
                {bottomLinkGroup.map((it, i) => (
                  <Fragment key={it.title}>
                    <Link href={it.link} target={'_blank'}>
                      {it.title}
                    </Link>
                    {i + 1 < bottomLinkGroup.length && ' | '}
                  </Fragment>
                ))}
              </p>
              {(!!layerData.bottom_info.icp_registration_txt || !!layerData.bottom_info.police_registration_txt) && (
                <p>
                  <Link href={layerData.bottom_info.icp_registration_link} target={'_blank'}>
                    {layerData.bottom_info.icp_registration_txt}
                  </Link>
                  <Link href={layerData.bottom_info.police_registration_link} rel="noreferrer" target={'_blank'}>
                    {layerData.bottom_info.police_registration_txt}
                  </Link>
                </p>
              )}
              {!!layerData.bottom_info.copyright_txt && (
                <p>
                  <span>{layerData.bottom_info.copyright_txt}</span>
                </p>
              )}
              {!!layerData.bottom_info.health_warning_txt && (
                <p>
                  <span>{layerData.bottom_info.health_warning_txt}</span>
                </p>
              )}
            </div>
            <div className={styles.r_bottom}>
              {!!layerData.ks_logo && (
                <Link
                  className={styles.footer_kingsoft_logo}
                  style={{ backgroundImage: `url('${layerData.ks_logo}')` }}
                  href={layerData.ks_logo_link}
                  target={'_blank'}
                />
              )}
              <Link
                className={styles.footer_seasun_logo}
                href={layerData.seasun_logo_link}
                target={'_blank'}
                style={{ backgroundImage: `url('${layerData.seasun_logo}')` }}
              />
            </div>
          </div>
          {!!layerData.nav_bar[4]?.qrcode_img && (
            <div
              className={cx(styles.qrcode_container, store.showQrCode && styles.qr_show)}
              style={{ backgroundImage: `url('${layerData.nav_bar[4]?.qrcode_img}')` }}
            />
          )}
        </div>
      ) : (
        <div className={styles.footer_container}>
          <div className={styles.footer_top} />
          <div className={styles.footer_bottom} />
        </div>
      )}
    </div>
  );
};

export default wrapStore(Footer, FooterStore);
